import { useContext, useEffect, useState } from "react";
import GridKeikkaEditor_Teksti_Row from "../teksti/GridKeikkaEditor_Teksti_Row";
import { GridContext } from "src/context/GridContext/GridContext";
import { differenceInMinutes } from "date-fns";
import { PalkkiIcon } from "src/components/icons/PalkkiIcons";
import PropTypes from "prop-types";

export default function GridKeikkaEditor_Teksti_Lisapalkit({ keikkaState }) {
  const { keikat } = useContext(GridContext) || {};
  const [palkit, setPalkit] = useState([]);

  useEffect(() => {
    if (!keikkaState) return;
    // find all palkit from keikat where keikka.isPalkki = true and both timeStart and timeEnd are between keikkaState.timeStart and keikkaState.timeEnd
    const filteredPalkit = keikat.filter(
      (k) =>
        k.isPalkki &&
        k.vehicleId === keikkaState.vehicleId &&
        Math.abs(differenceInMinutes(k.timeStart, keikkaState.timeStart)) < 11 &&
        Math.abs(differenceInMinutes(k.timeEnd, keikkaState.timeEnd)) < 61
    );
    setPalkit(filteredPalkit);
  }, [keikkaState]);

  if (!palkit || palkit.length === 0) return null;

  return (
    <>
      {palkit.map((palkki, index) => (
        <GridKeikkaEditor_Teksti_Row
          key={palkki.palkkiId}
          title={
            <div
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}>
              <PalkkiIcon palkki={palkki} />
              <i>{palkki.grid_palkkiType}</i>
            </div>
          }
          sub={palkki.keikkaComment}
          gray={index % 2 !== 0}
          isEditable={false}
        />
      ))}
    </>
  );
}

GridKeikkaEditor_Teksti_Lisapalkit.propTypes = {
  keikkaState: PropTypes.object,
};
